require('./ctxFileExplorer.style.scss');

const template = require('./ctxFileExplorer.template.html'),
    DEFAULT_START = 0,
    DEFAULT_COUNT = 40,
    HIDDEN_COUNT = 10,
    SCROLLING_STEPS = 5,
    DEFAULT_HEIGHT = 23;
let TREE_RANG_FIRST, TREE_RANG_LAST;

class FileExplorerController {
    constructor($element, $scope, $filter, $q, $timeout, sharedHelperService) {
        this.$element = $element;
        this.$scope = $scope;
        this.$filter = $filter;
        this.$q = $q;
        this.$timeout = $timeout;
        this.sharedHelperService = sharedHelperService;
        this.isIE = this.sharedHelperService.checkIfIE();
        this.configVariables();
        this.configTable();
        this.watchDiskForSelection();
        this.watchSelectedFiles();
        this.unmountedDiskSelected = false;

        // RELOAD => when page size is changed
        this.$scope.$watch(
            () => this.tableState && this.tableState.pageSize,
            (newValue, oldValue) => {
                if (!oldValue || oldValue === newValue) return;
                this.load();
            }
        );

        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (searchString, position) {
                position = position || 0;
                return this.indexOf(searchString, position) === position;
            };
        }
    }

    $onChanges(changes) {
        if (changes.isMounted && changes.isMounted.currentValue) {
            this.isLoading = true;
            this.foldersCallback().then(
                () => {
                    this.folderContentCallback().then(
                        () => {
                            this.onCallbackAction(this.disk, false, true);
                        },
                        (err) => {
                            this.isLoading = false;
                        }
                    );
                },
                (err) => {
                    this.isLoading = false;
                }
            );
        } else if (!changes.fullDiskSelected) {
            this.configVariables();
        }
    }

    load(refresh, onSort) {
        let folder = this.selected;
        if (!folder) return;
        if (refresh && this.searchBy) {
            folder.searchObject = this.searchValue ? { key: this.searchBy, value: this.searchValue } : null;
        }
        folder.fileTableState = this.tableState;
        if (!onSort && this.folderOrderBy) folder.fileTableState.orderBy = this.folderOrderBy;
        this.isLoading = true;
        this.folderContentCallback({ folder }).then(
            (res) => {
                this.onCallbackAction(folder, true, true);
                this.folderOrderBy = folder.fileTableState.orderBy;
            },
            (err) => {
                this.isLoading = false;
            }
        );
    }

    configVariables() {
        this.tableState = undefined;
        this.folderOrderBy = 'displayName';
        this.pathQuery = '';
        this.selectedPath = '';
        this.content = [];
        this.selectedFiles = [];
        this.isLoading = false;
        this.treeReloading = false;
        this.selected = null;
        TREE_RANG_FIRST = DEFAULT_START;
        TREE_RANG_LAST = DEFAULT_COUNT;
    }

    watchDiskForSelection() {
        this.$scope.$watchCollection(
            () => this.disk,
            () => {
                this.nodesSelected = this.disk._selected || this.disk.someSelected;
            }
        );
    }

    watchSelectedFiles() {
        this.$scope.$watchCollection(
            () => this.selectedFiles,
            () => {
                this.content.forEach((element) => {
                    if (
                        element.content &&
                        element.content.length !== 0 &&
                        (element._selected
                            ? !element.content.every((f) => f._selected)
                            : element.content.every((f) => f._selected))
                    ) {
                        this.updateChildren(element);
                    }
                });
                if (this.content[0]) {
                    this.updateParents(this.content[0]);
                }

                if (this.selectedFiles.filter((element) => element.mounted === false).length !== 0) {
                    this.unmountedDiskSelected = true;
                } else {
                    this.unmountedDiskSelected = false;
                }
            }
        );
    }

    configTable() {
        this.columnNames = [
            this.$filter('translate')('ctxFileExplorer.table.header.name'),
            this.$filter('translate')('ctxFileExplorer.table.header.type'),
            this.$filter('translate')('ctxFileExplorer.table.header.size'),
        ];
    }

    navigateToPath() {
        let path = '',
            domIndex = -1,
            currentFolder = this.disk;
        const folderNames = this.pathQuery ? this.pathQuery.split('/') : [];

        function findFolderIndex(folderName, isLast) {
            let index = -1,
                tempDomIndex = -1;
            for (let i = 0, len = currentFolder.folders.length; i < len; i++) {
                if (currentFolder.folders[i].fullItemName === folderName) {
                    index = i;
                    tempDomIndex = currentFolder.folders[i].visibleIndex;
                    break;
                }
            }
            return { index: index, domIndex: tempDomIndex >= 0 ? tempDomIndex : -1 };
        }

        let folderName = '';
        for (let i = 0, lenI = folderNames.length; i < lenI; i++) {
            if (!currentFolder) break;
            if (folderName.startsWith('/')) {
                //for some reason mount points have slash prefix, while others don't
                //so when going deeper, prefix should be removed
                folderName = folderName.replace('/', '');
            }
            folderName += '/' + folderNames[i];
            let lastI = i === lenI - 1;
            let res = findFolderIndex(folderName, lastI);
            // for shares first folder name do not have slash prefix
            if (i === 0 && res.index < 0) {
                folderName = folderName.replace('/', '');
                res = findFolderIndex(folderName, lastI);
            }
            if (lastI) domIndex = res.domIndex;
            const index = res.index;
            const isFolderMissing = index < 0 && !currentFolder.contentsLoaded;

            path = folderName;
            if (isFolderMissing) currentFolder.addPlaceholderSubFolder(folderName, path);
            currentFolder = isFolderMissing ? currentFolder.folders[0] : currentFolder.folders[index];
        }

        if (currentFolder) {
            this.toggleFolderContent(currentFolder);
        } else {
            this.content = [];
            this.selectedFiles = [];
            this.selectedPath = this.pathQuery;
        }
        this.$timeout(() => {
            // situation 1: element not exist
            if (domIndex < 0) return;
            // situation 2: navigate to element that is out of visible rang
            else if (domIndex < TREE_RANG_FIRST || domIndex > TREE_RANG_LAST) {
                let temp = {
                    first:
                        domIndex < TREE_RANG_FIRST || domIndex + DEFAULT_COUNT <= this.availableSteps
                            ? domIndex
                            : this.availableSteps - DEFAULT_COUNT,
                    index: domIndex,
                };
                if (temp) this.onUpdateAction(null, temp);
            }
            // situation 2: navigate to element that is in visible rang
            else {
                this.$timeout(() => {
                    let el = this.$element.find('.selected');
                    if (el[0]) this.treeContainer.mCustomScrollbar('scrollTo', () => el);
                }, 0);
            }
        }, 0);
    }

    setGrid(grid) {
        this.grid = grid;
        this.gridColumnsStyleConfig = {
            multiselect: true,
            columnsWidthMapInPct: [],
        };
        if (this.showModifiedDate) {
            this.columnNames.push(this.$filter('translate')('ctxFileExplorer.table.header.dateModified'));
            this.gridColumnsStyleConfig.columnsWidthMapInPct.push('5%');
            this.gridColumnsStyleConfig.columnsWidthMapInPct.push('35%');
            this.gridColumnsStyleConfig.columnsWidthMapInPct.push('15%');
            this.gridColumnsStyleConfig.columnsWidthMapInPct.push('15%');
            this.gridColumnsStyleConfig.columnsWidthMapInPct.push('30%');
        } else {
            this.gridColumnsStyleConfig.columnsWidthMapInPct.push('5%');
            this.gridColumnsStyleConfig.columnsWidthMapInPct.push('45%');
            this.gridColumnsStyleConfig.columnsWidthMapInPct.push('25%');
            this.gridColumnsStyleConfig.columnsWidthMapInPct.push('25%');
        }
        this.gridFlag = true;
    }

    singleClick(event, data) {
        if (this.clicked) {
            this.cancelClick = true;
            return;
        }
        this.clicked = true;
        this.$timeout(() => {
            if (this.cancelClick) {
                this.cancelClick = false;
                this.clicked = false;
                return;
            }
            this.toggleFolderContent(data);
            //clean up
            this.cancelClick = false;
            this.clicked = false;
        }, 250);
    }

    doubleClick(event, data) {
        this.$timeout(() => this.toggleFolder(data), 0);
    }

    toggleFolder(folder) {
        if (folder.contentsLoaded) {
            this.treeReloading = true;
            folder.isExpanded = !folder.isExpanded;
            this.collapsedElIndex = !folder.isExpanded ? folder.visibleIndex : null;
            if (this.disk && this.disk.folders) {
                this.availableSteps = this.setVisibleRenderIndex(this.disk.folders, 0);
            }
            this.treeReloading = false;
            this.setScrollableContainerHeight();
            return;
        } else {
            this.collapsedElIndex = null;
            this.treeReloading = true;
        }

        const noFiles = folder.content.length === 0;
        this.foldersCallback({ folder }).then(() => {
            if (noFiles) {
                return this.folderContentCallback({ folder }).then(() => {
                    this.onCallbackAction(folder, false, false);
                });
            } else {
                return this.onCallbackAction(folder, false, false);
            }
        });
    }

    toggleFolderContent(folder) {
        let customRefresh;
        if (folder.content.length === 0 && !folder.contentsLoaded) {
            this.isLoading = true;
            this.searchValue = null;
            if (this.folderOrderBy) folder.fileTableState.orderBy = this.folderOrderBy;
            this.folderContentCallback({ folder }).then(
                () => {
                    this.onCallbackAction(folder, true, true, true);
                },
                (err) => {
                    this.isLoading = false;
                }
            );
        } else {
            // RELOAD => when page size is not changed, but orderBy is changed
            if (this.tableState) {
                customRefresh =
                    this.tableState.pageSize === folder.fileTableState.pageSize &&
                    this.folderOrderBy &&
                    this.folderOrderBy !== folder.fileTableState.orderBy;
            }
            this.content = folder.content;
            this.tableState = folder.fileTableState;
            this.searchValue = folder.searchObject ? folder.searchObject.value : null;
        }
        this.pathQuery = folder.fullItemName;
        this.selectedPath = this.pathQuery;
        this.selected = folder;
        if (customRefresh) this.load();
    }

    onCallbackAction(folder, updateMainContent, updateTableState, updateSelected) {
        folder.hasExcluded = this.hasExcluded(folder);
        if (folder.hasExcluded) {
            if (folder._selected) {
                folder._selected = false;
                folder.someSelected = true;
            }
            this.updateChildren(folder, true);
            this.updateParentsSubExclusion(folder);
        }
        folder.content.forEach((f) => {
            if (f.iconType === 'icon-symfolder') {
                f.size = null;
            }
            f.sizeValue = f.size ? this.sharedHelperService.expressBytes(f.size) : '';
            if (updateMainContent) {
                updateSelected
                    ? this.updateSelectedItems(f, this.selectedFiles)
                    : this.updateOnReload(folder, f, this.selectedFiles);
            }
        });

        if (updateMainContent) this.content = folder.content;
        else {
            folder.contentsLoaded = true;
            folder.isExpanded = true;
        }
        if (updateTableState) this.tableState = folder.fileTableState;
        this.availableSteps = this.setVisibleRenderIndex(this.disk.folders, 0);
        this.isLoading = false;
        this.treeReloading = false;
        if (folder._selected && !folder.someSelected & !folder.hasExcluded) {
            this.updateSelectedItems(folder, this.selectedFiles);
            this.updateChildren(folder);
            this.updateParents(folder);
        }
        this.setScrollableContainerHeight();
    }

    selectFolder(folder) {
        const newValue = !folder._selected;
        folder._selected = newValue;
        folder.someSelected = false;
        this.updateSelectedItems(folder, this.selectedFiles);
        this.updateChildren(folder);
        this.updateParents(folder);
    }

    updateChildren(folder, hasSomeExcluded) {
        const newValue = hasSomeExcluded ? folder.someSelected : folder._selected;
        let ctrl = this;

        if (!hasSomeExcluded && folder.someSelected) return;
        if (!folder._selected && !folder.someSelected) {
            //remove folder children from this.selectedFiles, since, due to paging, not all are removed in updateChildren;
            this.selectedFiles = this.selectedFiles.filter((file) => {
                return file.parent
                    ? file.parent.uuid !== folder.uuid && file.parent.fullItemName !== folder.fullItemName
                    : true;
            });
        }

        function selectFiles(content, value, selectedFiles) {
            if (!content || !content.length) return;
            content.forEach((item) => {
                item._selected = value;
                ctrl.updateSelectedItems(item, selectedFiles);
            });
        }

        function selectSubFolders(subFolders, value, selectedFiles) {
            if (!subFolders || !subFolders.length) return;
            subFolders.forEach((item) => {
                item._selected = value;
                item.someSelected = false;
                selectSubFolders(item.folders, newValue, selectedFiles);
                selectFiles(item.content, newValue, selectedFiles);
                ctrl.updateSelectedItems(item, selectedFiles);
            });
        }
        selectFiles(folder.content, newValue, this.selectedFiles);
        selectSubFolders(folder.folders, newValue, this.selectedFiles);
        folder.someSelected = !hasSomeExcluded ? false : folder.someSelected;
    }

    updateParents(folder) {
        let ctrl = this;
        function selectParent(folder, selectedFiles) {
            if (!folder) return;
            let selectedChildrenLength = selectedFiles.filter(
                    (item) => item && item.parent && item.parent.uuid === folder.uuid
                ).length,
                areAllChildrenSelected = selectedChildrenLength === folder.fileTableState.countTotal,
                areSomeChildrenSelected =
                    selectedChildrenLength > 0 && selectedChildrenLength < folder.fileTableState.countTotal;

            const areFoldersSelected = folder.folders.every((f) => f._selected),
                someFoldersSelected = folder.folders.some((f) => f._selected),
                someSomeFoldersSelected = folder.folders.some((f) => f.someSelected);

            const areFilesSelected = folder.content.every((f) => f._selected),
                someFilesSelected = folder.content.some((f) => f._selected);

            folder._selected = areFoldersSelected && areFilesSelected && (folder._selected || areAllChildrenSelected);
            folder.someSelected =
                !folder._selected &&
                (areSomeChildrenSelected || someFoldersSelected || someFilesSelected || someSomeFoldersSelected);

            ctrl.updateSelectedItems(folder, selectedFiles);
            if (folder.parent) selectParent(folder.parent, selectedFiles);
        }
        selectParent(folder.parent, this.selectedFiles);
    }

    updateSelectedItems(item, selectedFiles) {
        let tempIndex = -1;
        selectedFiles.filter((f, index) => {
            if (f.uuid === item.uuid && f.fullItemName === item.fullItemName) tempIndex = index;
        });
        if (item._selected && tempIndex < 0) selectedFiles.push(item);
        else if (!item._selected && tempIndex > -1) selectedFiles.splice(tempIndex, 1);
    }

    updateOnReload(parent, item, selectedFiles) {
        let tempIndex = -1;
        // parent folder is selected
        if (parent._selected) {
            item._selected = true;
            item.someSelected = false;
            this.selectedFiles.filter((f, index) => {
                if (f.uuid === item.uuid && f.fullItemName === item.fullItemName) tempIndex = index;
            });
            if (tempIndex < 0) selectedFiles.push(item);
        }
        // no item in parent folder is selected
        else if (!parent.someSelected) {
            item._selected = false;
            item.someSelected = false;
            this.selectedFiles.filter((f, index) => {
                if (f.uuid === item.uuid && f.fullItemName === item.fullItemName) tempIndex = index;
            });
            if (tempIndex > -1) selectedFiles.splice(tempIndex, 1);
        }
    }

    getCheckboxClass(folder) {
        const noFolders = folder.folders.length === 0;
        const noFiles = folder.content.length === 0;
        if (noFiles && noFolders) return folder._selected ? 'icon-checkboxcheck' : 'icon-checkboxempty';

        if (folder._selected) return 'icon-checkboxcheck';
        if (folder.someSelected) return 'icon-checkboxcircle';
        return 'icon-checkboxempty';
    }

    explorerSearch() {
        if (this.tableState) this.tableState.page = 1;
        this.load(true);
    }

    setVisibleRenderIndex(folders, step) {
        folders.forEach((f) => {
            f.visibleIndex = step;
            step++;
            f.hasVisibleChildren = f.folders && f.folders.length && f.isExpanded;
            if (f.hasVisibleChildren) {
                step = this.setVisibleRenderIndex(f.folders, step);
            }
        });
        return step;
    }

    setScrollableContainerHeight() {
        if (!this.scrollableContainer || !this.scrollableContainer[0]) return;
        let steps = !this.isWindowsOs ? (!this.disk.isExpanded ? 1 : 1 + this.availableSteps) : this.availableSteps,
            height = steps * (this.treeItemHeight ? this.treeItemHeight : DEFAULT_HEIGHT);
        this.scrollableContainer.height(height);
        this.previous_mCSC_Height = height;
    }

    onScrollUpdateFn() {
        if (this.waitToReset) return;
        if (!this.treeContainer) {
            this.treeContainer = this.$element.find('.folder-tree');
            this.mCustomScrollbar = this.treeContainer.mCustomScrollbar();
            this.scrollableContainer = this.mCustomScrollbar.find('.mCSB_container');
        }
        let temp = this.treeContainer.find('.tree-row-item')[0];
        this.treeItemHeight = !temp ? 0 : temp.getBoundingClientRect().height;
        if (!this.treeItemHeight) {
            return;
        }
        // skip update - on resize
        if (
            this.treeItemHeight > 0 &&
            this.previous_itemHeight > 0 &&
            this.previous_itemHeight !== this.treeItemHeight
        ) {
            return;
        }
        // update - on scroll update
        this.setScrollableContainerHeight();
        return this.updateValues();
    }

    onUpdateAction(onResize, onTopUpdate) {
        if (!this.treeContainer) return;
        if (onResize && (!this.previous_mCSC_Height || this.waitToReset)) return;
        this.disableScroll();
        this.$timeout(() => {
            // onResize => on modal resize => height of tree-row-item can be changed => TOP and HEIGHT should be updated
            if (onResize) {
                // check if tree-row-item height is changed
                let temp = this.treeContainer.find('.tree-row-item')[0];
                this.treeItemHeight = !temp ? 0 : temp.getBoundingClientRect().height;
                if (this.previous_itemHeight >= 0 && this.treeItemHeight === this.previous_itemHeight) {
                    return this.enableScroll();
                }
                // reset scrollable container height
                let height = this.availableSteps * this.treeItemHeight,
                    heightDiff = height - this.previous_mCSC_Height;
                this.scrollableContainer.height(height);
                // if new height is smaller than previous one, reset top also
                if (heightDiff < 0) {
                    let top = this.previous_mCSC_Top + heightDiff;
                    this.scrollableContainer.css({ top: top + 'px' });
                    this.previous_mCSC_Top = top;
                }
            }
            // onTopUpdate => on navigate to path => if element is out of visible rang => TOP should be updated
            if (onTopUpdate) {
                let topRowCount = onTopUpdate.first + HIDDEN_COUNT;
                this.scrollableContainer.css({ top: topRowCount * this.treeItemHeight + 'px' });
            }
            this.updateValues();
            this.$timeout(() => {
                this.enableScroll();
                if (!onTopUpdate) return;
                // onTopUpdate => scroll to element
                let domEl = this.$element.find('.tree-row-item[visible-index="' + onTopUpdate.index + '"]');
                if (domEl[0]) this.treeContainer.mCustomScrollbar('scrollTo', () => domEl);
            }, 0);
        }, 0);
    }

    updateValues() {
        if (this.isIE) {
            return this.update();
        }
        this.$timeout(() => this.update(), 0);
    }

    update() {
        if (!this.treeItemHeight) {
            let temp = this.treeContainer.find('.tree-row-item')[0];
            this.treeItemHeight = !temp ? 0 : temp.getBoundingClientRect().height;
            if (this.treeItemHeight) this.setScrollableContainerHeight();
        }
        let top = Math.abs(this.scrollableContainer.position().top),
            topRowsCount = Math.floor(top / this.treeItemHeight),
            temp = topRowsCount - HIDDEN_COUNT;
        TREE_RANG_FIRST = Number.isFinite(temp) && temp >= 0 ? temp : 0;
        TREE_RANG_LAST = TREE_RANG_FIRST + DEFAULT_COUNT;
        if (!Number.isFinite(temp)) {
            top = 0;
            this.scrollableContainer.css({ top: top + 'px' });
        }
        this.topNotDisplayed = TREE_RANG_FIRST * this.treeItemHeight;
        this.previous_mCSC_Top = top;
        this.previous_mCSC_Height = this.availableSteps * this.treeItemHeight;
        this.previous_itemHeight = this.treeItemHeight;
    }

    disableScroll() {
        this.waitToReset = true;
        this.treeReloading = true;
        this.treeContainer.mCustomScrollbar('disable', true);
    }

    enableScroll() {
        this.treeReloading = false;
        this.treeContainer.mCustomScrollbar('update');
        this.waitToReset = false;
    }

    whileScrollingFn() {
        if (this.waitToReset || !this.treeContainer) return;
        let top = Math.abs(this.scrollableContainer.position().top);
        // reset visible rang on (SCROLLING_STEPS)
        if (Math.abs(top - this.previous_mCSC_Top) / this.treeItemHeight <= SCROLLING_STEPS) {
            return;
        }
        this.updateValues();
    }

    customTreeFilter(item) {
        return item.hasVisibleChildren || (item.visibleIndex >= TREE_RANG_FIRST && item.visibleIndex <= TREE_RANG_LAST);
    }

    onScrollEndFn() {
        if (!this.treeContainer || this.waitToReset) return;
        this.$timeout(() => this.updateValues(), 0);
    }

    checkDomVisibility(visibleIndex) {
        return visibleIndex >= TREE_RANG_FIRST && visibleIndex <= TREE_RANG_LAST;
    }

    hasExcluded(folder) {
        return (
            folder.folders.filter((f) => !!f.excluded || f.hasExcluded).length > 0 ||
            folder.content.filter((f) => !!f.excluded || f.hasExcluded).length > 0
        );
    }

    updateParentsSubExclusion(folder) {
        function selectSubExclusion(folder) {
            if (!folder) return;
            folder.hasExcluded = true;
            if (folder._selected) {
                folder._selected = false;
                folder.someSelected = true;
            }
            if (folder.parent) selectSubExclusion(folder.parent);
        }
        selectSubExclusion(folder.parent);
    }
}

const fileExplorerComponent = {
    controller: FileExplorerController,
    template: template,
    bindings: {
        selectedFiles: '=',
        disk: '<',
        nodesSelected: '=',
        isMounted: '<',
        folderContentCallback: '&',
        foldersCallback: '&',
        flexiblePaging: '<?',
        searchBy: '<?',
        showModifiedDate: '<?',
        isWindowsOs: '=?',
        isBusy: '=?',
        resizeCounter: '<?',
        fullDiskSelected: '<?',
        unmountedDiskSelected: '=?',
    },
};

FileExplorerController.$inject = ['$element', '$scope', '$filter', '$q', '$timeout', 'sharedHelperService'];

module.exports = fileExplorerComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxFileExplorer/ctxFileExplorer.component.js